import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import gibletLogo from '@/assets/giblet-logo.png';

export default function DemoCallForKnowledgeForm() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-2xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <img src={gibletLogo} alt="Giblet Logo" className="h-16 w-auto" />
        </div>

        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold text-foreground">Call for Knowledge (CfK)</h1>
          <p className="text-xl text-muted-foreground">
            Gather expertise and insights from the iSPAI community
          </p>
        </div>

        <div className="bg-card rounded-lg p-8 shadow-lg space-y-6">
          <div className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">Purpose</h2>
            <p className="text-muted-foreground leading-relaxed">
              A Call for Knowledge (CfK) is used when you need to gather expertise, insights, or documentation
              from domain experts. This could be for expanding existing knowledge bases, understanding best practices,
              or documenting proven methodologies.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">Instructions</h2>
            <ol className="list-decimal list-inside space-y-3 text-muted-foreground">
              <li>Select your channel or domain area for this knowledge contribution</li>
              <li>Choose whether this CfK is connected to an existing Call for Solution</li>
              <li>Define the specific knowledge gap you're trying to fill</li>
              <li>Specify requirements and scope for knowledge contributions</li>
              <li>Assign roles (Curator, Contributors, Confirmer) for knowledge validation</li>
              <li>Review and submit your Call for Knowledge</li>
            </ol>
          </div>

          <div className="bg-primary/10 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-foreground">Key Benefits:</h3>
            <ul className="space-y-1 text-muted-foreground text-sm">
              <li>• Tap into collective intelligence of domain experts</li>
              <li>• Build comprehensive, validated knowledge bases</li>
              <li>• Document proven methodologies and best practices</li>
              <li>• Support AI agents with authoritative grounding data</li>
              <li>• Create reusable IP assets with proper attribution</li>
            </ul>
          </div>
        </div>

        <div className="flex justify-center gap-4">
          <Button
            variant="outline"
            onClick={() => navigate('/curt-channel')}
            className="min-w-[120px]"
          >
            Back
          </Button>
          <Button
            onClick={() => navigate('/demo-call-for-knowledge/functional-area')}
            className="min-w-[120px]"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
